import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import { IAuthSettingsState } from '@piwikpro/auth-crate/reducers/auth';
import { connect } from 'react-redux';
import TwoFactorAuth from './TwoFactorAuth';

const mapStateToProps = (state: {
  session: SessionState
  authSettings: IAuthSettingsState
}) => ({
  userId: state.session.userId,
  twoFactorAuth: state.authSettings.user.twoFactorAuth,
  isLoading: state.authSettings.user.isLoading,
  failed: state.authSettings.user.failed,
});

export default connect(mapStateToProps, null)(TwoFactorAuth);
